import * as React from 'react'

import {
  ColorScheme,
  TcolorScheme
} from '~/experiments/color-scheme/ColorScheme'
import { styled } from '~/styled'

import { Dismissible } from '../dismissible'
import { useBannerContext } from './BannerContext'

const StyledBannerContainer = styled(
  'section',
  {
    base: [
      'flex',
      'relative',
      'w-full',
      'rounded-lg',
      'overflow-hidden',
      'text-(--foreground)',
      '[--banner-heading-color:var(--color-foreground)]',
      '[--banner-text-color:var(--color-grey-900)]'
    ],
    variants: {
      emphasis: {
        bold: [
          '[--banner-heading-color:var(--color-foreground-7-plus)]',
          '[--banner-text-color:var(--color-grey-100)]',
          'bg-(--base-11)',
          'text-(--foreground-7-plus)'
        ],
        subtle: ['bg-(--base-3)'],
        minimal: ['bg-(--base-1)']
      },
      size: {
        sm: [],
        md: []
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

export type TBannerContainerProps = React.ComponentProps<
  typeof StyledBannerContainer
> & {
  colorScheme?: TcolorScheme
} & React.ComponentProps<typeof Dismissible>

export const BannerContainer = ({
  colorScheme = {},
  onDismiss,
  dismissed,
  ...props
}: TBannerContainerProps): React.JSX.Element => {
  const { emphasis } = useBannerContext()

  return (
    <ColorScheme {...colorScheme} asChild>
      <Dismissible asChild onDismiss={onDismiss} dismissed={dismissed}>
        <StyledBannerContainer role="banner" emphasis={emphasis} {...props} />
      </Dismissible>
    </ColorScheme>
  )
}
